import React from 'react'
import Text from 'antd/es/typography/Text'
import { Radio } from 'antd'
import { textSubmissionDrawerActions } from '../../../../../store/slices/text-submission-drawer.slice'
import { useDispatch, useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../store/selectors/text-submission-drawer.selectors'

export const GradingModes = {
    BY_QUESTION: 'by-question',
    BY_STUDENT: 'by-student',
    BY_RUBRIC: 'by-rubric',
    MANUAL: 'manual',
}

export const getGradingModeName = value => {
    if (value === GradingModes.BY_QUESTION) return 'By Question'
    if (value === GradingModes.BY_STUDENT) return 'By Student'
    if (value === GradingModes.BY_RUBRIC) return 'By Rubric'
    if (value === GradingModes.MANUAL) return 'Manual'
    return 'Unknown'
}

export const getGradingModeDescription = value => {
    if (value === GradingModes.BY_QUESTION)
        return 'Stay on the same question across all students. Approving a question takes you to the next student. For complex questions, progress only after grading all rubrics for that question.'
    if (value === GradingModes.BY_STUDENT)
        return 'Focus on grading one student at a time. Clicking “Approve” advances to the next ungraded question for the current student. Once all questions are graded, move to the next student automatically.'
    if (value === GradingModes.BY_RUBRIC)
        return 'Grade one rubric at a time across all students. Approving a rubric advances to the next student while staying on the same question and rubric.'
    if (value === GradingModes.MANUAL)
        return 'Take full control of the navigation. No automatic advancing or scrolling—move through students and questions as you choose.'
    return 'Unknown'
}

const GradingModeSelect = () => {
    const gradingMode = useSelector(textSubmissionDrawerSelectors.gradingMode)
    const dispatch = useDispatch()

    const options = Object.values(GradingModes).map(gradingMode => ({
        value: gradingMode,
        label: getGradingModeName(gradingMode),
        title: getGradingModeDescription(gradingMode),
    }))

    return (
        <label className='d-flex'>
            <Text type='secondary' className='d-flex-center mr-8'>
                Grading mode
            </Text>
            <Radio.Group
                options={options}
                value={gradingMode}
                onChange={event => dispatch(textSubmissionDrawerActions.setGradingMode(event.target.value))}
                optionType='button'
            />
        </label>
    )
}

export default GradingModeSelect
